// extracted by mini-css-extract-plugin
export default {"content":"ModalConfirm_content__jkYV8","buttons-group":"ModalConfirm_buttons-group__RsGTm"};